import React, { useState, useEffect } from "react";
import "../../Styles/AddClassesSubjects.css";
import axios from "axios";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loader from "../../Components/Loader";
function AddClassesSubjects() {
    const [subjects, setSubjects] = useState([""]);
    const [classes, setClasses] = useState([""]);
    const [semesters, setSemesters] = useState([""]);
    const [organizationName, setOrganizationName] = useState("");
    const [loading, setLoading] = useState(false);
    const [formSubmitted, setFormSubmitted] = useState(false);

    useEffect(() => {
        const checkIfFormSubmitted = async () => {
            try {
                const token = localStorage.getItem("authToken");
                if (!token) {
                    return;
                }

                const response = await axios.get("https://api.uniums.com/api/admin/get-class-subjects", {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });

                if (response.data) {
                    setFormSubmitted(true);
                }
            } catch (error) {
                console.error("Error checking form submission status:", error);
            }
        };

        checkIfFormSubmitted();
    }, []);

    useEffect(() => {
        const fetchOrganizationName = async () => {
            try {
                const response = await axios.get("https://api.uniums.com/api/admin/admin-organization", {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("authToken")}`
                    }
                });
                setOrganizationName(response.data.organizationName);
            } catch (error) {
                toast.error("Failed to fetch organization name!");
            }
        };

        fetchOrganizationName();
    }, []);

    const handleAddField = (setter, currentValues) => {
        setter([...currentValues, ""]);
    };

    const handleInputChange = (index, value, setter, currentValues) => {
        const updatedValues = [...currentValues];
        updatedValues[index] = value;
        setter(updatedValues);
    };
    const handleRemoveField = (index, setter, currentValues) => {
        const updatedValues = currentValues.filter((_, i) => i !== index);
        setter(updatedValues);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const token = localStorage.getItem("authToken");

        if (!token) {
            toast.error("You need to be logged in to submit.");
            return;
        }

        setLoading(true);

        try {
            const response = await axios.post(
                "https://api.uniums.com/api/admin/save-class-subjects",
                {
                    organizationName,
                    subjects,
                    classes,
                    semesters
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            toast.success(response.data.message);
            setFormSubmitted(true);
        } catch (error) {
            toast.error("An error occurred while saving the data.");
        } finally {
            setLoading(false);
        }
    };

    const renderInputs = (values, setter, label) => (
        <div className="form-group">
            <label>{label}:</label>
            <div className="dynamic-fields">
                {values.map((value, index) => (
                    <React.Fragment key={`${label}-${index}`}>
                        {index % 3 === 0 && <div className="input-row"></div>}
                        <div className="input-wrapper">
                            <input
                                type="text"
                                value={value}
                                onChange={(e) =>
                                    handleInputChange(index, e.target.value, setter, values)
                                }
                                placeholder={`${label} ${index + 1}`}
                            />
                            <button
                                className="remove-btn"
                                onClick={() => handleRemoveField(index, setter, values)}
                            >
                                ✖
                            </button>
                            {index === values.length - 1 && (
                                <button
                                    className="add-more-btn"
                                    onClick={() => handleAddField(setter, values)}
                                >
                                    +
                                </button>
                            )}
                        </div>
                    </React.Fragment>
                ))}
            </div>
        </div>
    );


    return (
        <div className="AddClassesSubjects">
            {formSubmitted ? (
                <h2 className="already_submitted">You have already submitted your data.</h2>
            ) : (
                <>
                    <h1>Add Classes, Subjects, and Semesters</h1>
                    <div className="form-container">
                        <div className="form-group">
                            <label>Organization Name:</label>
                            <input
                                type="text"
                                value={organizationName}
                                onChange={(e) => setOrganizationName(e.target.value)}
                                placeholder="Enter Organization Name"
                                disabled
                            />
                        </div>
                        {renderInputs(subjects, setSubjects, "Subjects")}
                        {renderInputs(classes, setClasses, "Classes")}
                        {renderInputs(semesters, setSemesters, "Semesters")}
                        <button className="submit-btn" onClick={handleSubmit} disabled={loading}>
                            {loading ? (
                                <span>Loading...</span>
                            ) : (
                                "Submit"
                            )}
                        </button>
                    </div>
                </>
            )}


            <ToastContainer />
        </div>
    );
}

export default AddClassesSubjects;
